import React, { useEffect } from 'react';
import styles from './QuizList.module.css';
import { NavLink } from 'react-router-dom';
import Loader from '../../components/UI/Loader';
import { connect } from 'react-redux';
import { fetchQuizes } from '../../store/actions/quiz';
import { bool, func, arrayOf, shape, number, string, oneOfType } from 'prop-types';

const QuizList = ({ loading, quizes, error, fetchQuizes }) => {

  useEffect(() => {
    fetchQuizes()
  }, []) //eslint-disable-line

  const renderQuizes = () => quizes.map(({ id, name }) => (
    <li
      key={id}
    >
      <NavLink to={`/quiz/${id}`}>
        {name}
      </NavLink>
    </li>
  )
  )

  return (
    <div className={styles.quizList}>
      <div>
        <h1>Список тестов</h1>

        {error ? <p className={styles.error}>Во время загрузки произошла ошибка.</p> :
          loading && quizes.length
            ? <Loader />
            : <ul>{renderQuizes()}</ul>
        }
      </div>
    </div>
  )
}

QuizList.propTypes = {
  loading: bool,
  fetchQuizes: func,
  quizes: arrayOf(shape({
    id: oneOfType([
      string, number
    ]).isRequired,
    name: string,
  })),
}

QuizList.defaultProps = {
  loading: false,
  fetchQuizes: () => { },
  quizes: arrayOf(shape({
    id: 1,
    name: 'name',
  })),
}

export default connect(({ quiz: { quizes, loading, error } }) => ({ quizes, loading, error }), { fetchQuizes })(QuizList)